import React from 'react';

const footer = () => {
    return (
        <div style={{ background: '#091C29', }}>
            <p className="text-white font-dosis text-center py-4">Designed & Developed With Utmost Enthusiasm By Jahidul Islam</p>
        </div>
    );
};

export default footer;